// Indonesian mobile numbers, E.164: +62 8xx, 9 to 12 digits after the country code
const PHONE_PATTERN = /^\+628\d{8,11}$/;

/** 0857..., 62857..., +62 857-... -> +62857...; '' when it is not an Indonesian mobile number. */
export const normalizePhone = (raw: string): string => {
  let digits = raw.replace(/[\s\-().]/g, '');
  if (digits.startsWith('+')) {
    digits = digits.slice(1);
  } else if (digits.startsWith('0')) {
    digits = `62${digits.slice(1)}`;
  }
  const phone = `+${digits}`;
  return PHONE_PATTERN.test(phone) ? phone : '';
};

/** +6285776572632 -> +62 857-****-2632 */
export const maskPhone = (phone: string): string => {
  if (!phone.startsWith('+62') || phone.length < 10) return phone;
  const national = phone.slice(3);
  return `+62 ${national.slice(0, 3)}-****-${national.slice(-4)}`;
};
